import React, { useState } from 'react'

import { Button, message, Typography, InputNumber, Form } from 'antd'

import { observer } from 'mobx-react-lite'

import { FlexBoxX, Box } from 'common/components/boxes'
import { Page } from 'common/components/Page'

import { useVendorStores } from 'vendor/hooks/use-stores'

const tooltipText =
  'Every time that your users respond to a quote, the default expiration date would show up as today plus the number of days you have selected as your Default Quote Expiration. For example if you are responding to a quote on January 2nd and your Default Quote Expiration is 10 days, then the expiration date will be auto set to January 12th. Note that for each individual quote, this value can be overridden by your users.'

export const OtherSettings = observer(() => {
  const { vendorSettingStore, userStore } = useVendorStores()

  const [isSubmitting, setSubmitting] = useState(false)

  const [form] = Form.useForm()

  const handleSubmit = async (formValues) => {
    setSubmitting(true)

    try {
      const { default_quote_valid_for_days } = formValues
      await vendorSettingStore.updateCurrentVendor({ default_quote_valid_for_days })
      message.success('Successfully saved changes')
    } catch (error) {
      if (error?.response?.data?.error) {
        message.error(error.response.data.error)
      } else {
        message.error(`Unable to save changes`)
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Form
      initialValues={{ default_quote_valid_for_days: userStore.currentUser?.vendor?.default_quote_valid_for_days }}
      layout="vertical"
      form={form}
      onFinish={handleSubmit}
      style={{ width: '100%' }}
    >
      <Page.Header>
        <FlexBoxX justifyContent="space-between" width="100%">
          <Typography.Title level={4} style={{ margin: 0 }}>
            Other Settings
          </Typography.Title>

          <Button type="primary" htmlType="submit" loading={isSubmitting}>
            Save Changes
          </Button>
        </FlexBoxX>
      </Page.Header>

      <Page.Content>
        <Box>
          <Form.Item
            required
            name="default_quote_valid_for_days"
            tooltip={tooltipText}
            label="Default Quote Expiration (days)"
          >
            <InputNumber style={{ minWidth: 190 }} />
          </Form.Item>
        </Box>
      </Page.Content>
    </Form>
  )
})
